import cardiMateImg from 'assets/images/cardimate-refund.png'
import danceBitImg from 'assets/images/dancebit-refund.png'
import famioImg from 'assets/images/famio-refund.png'
import fitmeImg from 'assets/images/fitme-redund.png'
import luvlyImg from 'assets/images/luvly-refund.png'
import nutriMateImg from 'assets/images/nutrimate-refund.png'

import { AppName, Color } from 'root-constants'

export const APP_IMAGES_DATA = {
  [AppName.DANCEBIT]: danceBitImg,
  [AppName.LUVLY]: luvlyImg,
  [AppName.NUTRIMATE]: nutriMateImg,
  [AppName.NUTRI_WALKING]: nutriMateImg,
  [AppName.CARDIMATE]: cardiMateImg,
  [AppName.FITME]: fitmeImg,
  [AppName.FAMIO]: famioImg,
}
export const APP_COLORS_DATA = {
  [AppName.DANCEBIT]: Color.DANCEBIT,
  [AppName.LUVLY]: '#FF7262',
  [AppName.NUTRIMATE]: Color.NUTRIMATE,
  [AppName.NUTRI_WALKING]: Color.NUTRI_WALKING,
  [AppName.CARDIMATE]: '#EE004A',
  [AppName.FITME]: Color.FITME,
  [AppName.FAMIO]: Color.FAMIO,
}
